import Layout from '@/layout/layout'

const featureRouter = {
  path: '',
  component: Layout,
  redirect: 'noRedirect',
  name: '',
  children: [
    {
      path: 'dataStatistics',
      component: () => import('@/views/dataStatistics/index'),
      name: '环比数据统计',
      meta: { title: '环比数据统计', noCache: true, fixed: true }
    },
    // {
    //   path: 'demo',
    //   component: () => import('@/views/demo'),
    //   name: '组件演示',
    //   meta: { title: '组件演示', noCache: true }
    // }
  ]
}

export default featureRouter
